import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';

@Injectable({
    providedIn: 'root'
})

export class AlertService {


    constructor(
        public afs: AngularFirestore,   // Inject Firestore service
    ) {

    }


    async getAdminMessage() {
        return this.afs.collection('adminAlerts').doc('content').valueChanges();
    }

    async getSignalMessage() {
        return this.afs.collection('adminAlerts').doc('signals').valueChanges();
    }
}
